import {
  buildFieldListForPrompt,
  serializeFieldList,
  CLASSIFIER_FIELD_DETAILS,
  CLASSIFIER_FIELD_FORMATS,
} from './fieldListPure';

const OPENAI_SYSTEM_PREFIX = 'Respond only with a valid JSON object with the following keys: client_type, client_type_confidence, asked_for, subject, results. Ensure all keys are present in the response.';

export function estimateTokens(text) {
  if (!text) return 0;
  return Math.ceil(String(text).length / 4);
}

export function resolvePromptForEstimate(promptTemplate, fieldList, text, options = {}) {
  const {
    detail = 'full',
    format = 'json',
  } = options;
  const built = buildFieldListForPrompt(fieldList, detail);
  const fieldsSerialized = serializeFieldList(built, format);
  return (promptTemplate || '')
    .replace(/\{\{FIELDS\}\}/g, fieldsSerialized)
    .replace(/\{\{TEXT\}\}/g, text || '')
    .replace(/\{\{CLIENT_TYPE\}\}/g, 'unknown');
}

export { CLASSIFIER_FIELD_DETAILS, CLASSIFIER_FIELD_FORMATS, buildFieldListForPrompt, serializeFieldList };

export function estimateInputTokensForCall(provider, resolvedPrompt) {
  const userTokens = estimateTokens(resolvedPrompt);
  if (provider === 'openai') {
    return userTokens + estimateTokens(OPENAI_SYSTEM_PREFIX);
  }
  return userTokens;
}

export function computeCostUsd(entry, inputTokens, outputTokens) {
  if (!entry) return null;
  const inTok = Number(inputTokens) || 0;
  const outTok = Number(outputTokens) || 0;
  return (inTok / 1e6) * entry.inputPer1M + (outTok / 1e6) * entry.outputPer1M;
}

export function estimateClassifierCost({
  catalogue,
  provider,
  model,
  resolvedPrompt,
  outputTokens,
}) {
  const entry = (catalogue?.models || []).find(
    (m) => m.provider === provider && m.model === model,
  );
  if (!entry) return null;
  const inputTokens = estimateInputTokensForCall(provider, resolvedPrompt);
  const outTokens = outputTokens ?? catalogue?.estimatedOutputTokens ?? 150;
  const costUsd = computeCostUsd(entry, inputTokens, outTokens);
  return {
    inputTokens,
    outputTokens: outTokens,
    costUsd,
    per1000Usd: costUsd * 1000,
  };
}

export function formatCostUsd(usd) {
  if (usd == null || !Number.isFinite(usd)) return '—';
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(3)}`;
}

export function formatContextWindow(n) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(0)}M`;
  if (n >= 1000) return `${Math.round(n / 1000)}k`;
  return String(n);
}

export function groupCatalogueByProvider(catalogue) {
  const groups = {openai: [], anthropic: []};
  (catalogue?.models || []).forEach((m) => {
    if (groups[m.provider]) groups[m.provider].push(m);
  });
  return groups;
}
